import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import moment from 'moment'


let initialLanguage = localStorage['sts-lang'] || navigator.language || navigator.userLanguage || 'nl-BE'
export const availableLanguages = ['nl-BE', 'fr-BE', 'en-GB']
initialLanguage = availableLanguages.find(lang => lang === initialLanguage) || availableLanguages.find(lang => lang.substring(0, 2) === initialLanguage.substring(0, 2)) || 'nl-BE'


Vue.use(VueI18n)
let initialTranslations = require(`@/lang/${initialLanguage}.json`)

const messages = {}
messages[initialLanguage] = initialTranslations

Vue.use(VeeValidate, {
    locale: initialLanguage,
})

export const i18n = new VueI18n({
    locale: initialLanguage,
    fallbackLocale: initialLanguage,
    messages,
})

setVeeValidateTranslations(initialLanguage, require(`vee-validate/dist/locale/${initialLanguage.substring(0, 2)}.js`))

const loadedLanguages = [initialLanguage]

export const loadLanguageAsync = async lang => {
    if (!lang) {
        return i18n.locale
    }

    if (i18n.locale === lang) {
        return lang
    }

    if (!loadedLanguages.includes(lang)) {
        const [msgs, validationMessages] = await Promise.all([import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`), import(/* webpackChunkName: "lang-val-[request]" */ `vee-validate/dist/locale/${lang.substring(0, 2)}.js`)])

        i18n.setLocaleMessage(lang, msgs.default)
        i18n.locale = lang

        setVeeValidateTranslations(lang, validationMessages.default)
        loadedLanguages.push(lang)
    }

    i18n.locale = lang
    moment.locale(lang.substring(0, 2))
    VeeValidate.Validator.localize(lang)
    return lang
}

function setVeeValidateTranslations(lang, translations) {
    translations.custom = {}
    translations.custom[i18n.t('form-elements.explain_sleep_complaint')] = { max: i18n.t('form-elements.explain_sleep_complaint_max_error') }
    translations.custom[i18n.t('pages.schedule.did_you_nap')] = { time_required: i18n.t('pages.schedule.did_you_nap_error') }
    translations.messages.max = (fieldName, params) => i18n.t('validation.max', { fieldName: fieldName, characters: params[0] })

    const veeValidateLang = {}
    veeValidateLang[lang] = translations

    VeeValidate.Validator.localize(veeValidateLang)
}
